export default text => text[0].toUpperCase() + text.substr(1);
